const menuLinkBtn = document.querySelectorAll("header-menu .linkBtn");
const menulinks = document.querySelectorAll(".link-action");
const menuLinksDrawer = document.querySelectorAll("header-menu .linkBtn + ul");
const menuLink = document.querySelectorAll("header-menu");
const menuWrapper = document.querySelector('.header-wrapper');
const menuItems = document.querySelectorAll('.header__menu-item');
// const header_wrapper = document.querySelector(".header-wrapper");

menulinks.forEach((button, index) => {
    button.addEventListener("mouseenter", (event) => {
      menuLinksDrawer.forEach( (drawer) =>{
          drawer.classList.add("header__submenu-hidden");
          menulinks[index].classList.remove("header__menu-item-active");
      });
      menuLinkBtn.forEach( (link) =>{
        link.classList.remove("header__menu-item-active");
      });
      loginDrawer.classList.add("header__submenu-hidden");
      loginBtn.classList.remove("header__menu-item-active");
    });
  });

menuLinkBtn.forEach((button, index) => {
  button.addEventListener("mouseenter", (event) => {
    if(header_wrapper.classList.contains('header-transparent')){
      header_wrapper.classList.remove('header-transparent');
    }
    menuLinkBtn[index].classList.add("header__menu-item-active");
    menuLinksDrawer.forEach( (drawer) =>{
        drawer.classList.add("header__submenu-hidden");
    });
    menuLinksDrawer[index].classList.remove("header__submenu-hidden");
    menuWrapper.addEventListener("mouseleave", (event) => {
        event.preventDefault();
        menuLinksDrawer[index].classList.add("header__submenu-hidden");
        menuLinkBtn.forEach( (link) =>{
          link.classList.remove("header__menu-item-active");
        });
      });
  });

});

